import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ComparablesTabs } from '../../enum';
import { NavigationActionBase } from '../../navigation-action-base';
import { NavigationService } from '../../navigation.service';
import { EventBusService } from '../../../services/event-bus.service';
import { AppStorageService } from '../../../services/app-storage.service';
/**
 * Handles the comparables actions navigation component
 */
@Component({
  selector: 'comparables-actions-navigation',
  templateUrl: './comparables-actions-navigation.component.html'
})

export class ComparablesActionsNavigationComponent extends NavigationActionBase implements OnInit {
  /**
   * Search tab visible flag
   */
  @Input() searchTabVisible: boolean;
  /**
   * Selected tab
   */
  @Input() selectedTab: ComparablesTabs;
  /**
   * Change detector reference
   */
  _ref: ChangeDetectorRef;
  /**
   * Navigation service
   */
  _navigationService: NavigationService;
  /**
   * Search mode
   */
  searchMode = 'comparablesProperty';
  /**
   * Constructor
   * @param ais
   * @param ref
   * @param navigationService
   */
  constructor(appStorage: AppStorageService,
    ref: ChangeDetectorRef,
    navigationService: NavigationService,
    eventBus: EventBusService) {
    super(appStorage, eventBus, ref, navigationService);
    this._ref = ref;
    this._navigationService = navigationService
  }
  /**
   * Gets active tab
   */
  public get activeTab(): typeof ComparablesTabs {
    return ComparablesTabs;
  }
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    super.ngOnInit();
    this.subscribeToActiveTab();
  }
  /**
   * Subscribe to active tab
   */
  subscribeToActiveTab() {
    this.subscriptions.add(this._navigationService.activeComparablesTab$.subscribe(tab => {
      this.selectedTab = tab;

      switch (this.selectedTab) {
        case ComparablesTabs.Leases:
          this.searchMode = 'comparablesLease';

          break;
        case ComparablesTabs.Properties:
          this.searchMode = 'comparablesProperty';

          break;
        case ComparablesTabs.Valuations:
          this.searchMode = 'comparablesValuation'

          break;
      }

      if (this.searchTabVisible) {
        this.searchTabVisible = !this.searchTabVisible;
      }

      this._ref.markForCheck();
    }))
  }
  /**
   * Save cancel actions clicked
   * @param save
   */
  saveCancelActionsClicked(save: boolean) {
    let action: string;
    switch (this.selectedTab) {
      case ComparablesTabs.Leases:
        action = save ? 'saveLeaseData' : 'cancelLeaseDataChanges';
        this.searchMode = 'comparablesProperty';
        break;
      case ComparablesTabs.Properties:
        action = save ? 'savePropertyData' : 'cancelPropertyDataChanges';
        this.searchMode = 'comparablesValuation'

        break;
      case ComparablesTabs.Valuations:
        action = save ? 'saveValuationsData' : 'cancelPortfolioValuationsDataChanges';
        this.searchMode = 'comparablesLease';

        break;
    }

    this.saveCancelActions(action);
  }
  /**
   * Set search bar visibility
   */
  setSearchBarVisibility() {
    this.searchTabVisible = !this.searchTabVisible;
    this.eventBus.broadcastEvent('searchBarVisibility', this.searchTabVisible, this.searchMode);
  }
}
